import React from 'react'
import "./Footer.css"

const Footer = () => {
  return (
    <div className='BaseDivFooter'>
        <div className='contentFooter'>
            
        </div>
        <div className='underFooter'>
           <p></p>
           <p>© 2023 msp - All rights reserved.</p>
        </div>
    </div>
  )
}

export default Footer